export { default } from './Switch';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Switch/index.js
// module id = 357
// module chunks = 0